import { Text, Flex, Loader, Button } from '@components';
import { useUserQuery, useVerifyEmailMutation } from '@features/api/userSlice';
import { useAuth } from '@hooks/useAuth';
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';

const EmailVerificationRequest = () => {
  const [verifyEmailMutation, { error, isSuccess, isLoading, isError }] =
    useVerifyEmailMutation();
  const { logout } = useAuth();
  const navigate = useNavigate();

  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get('token');

  const { data: user } = useUserQuery(undefined, {
    skip: token === null,
  });

  useEffect(() => {
    const init = async () => {
      if (token) {
        await verifyEmailMutation({ token }).unwrap();
      }
    };

    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const handleGoToLogin = async () => {
    if (user) {
      await logout();
    }
    navigate('/login');
  };

  if (isError || !token) {
    if (
      (error as any)?.data?.detail === 'EMAIL VERIFICATION REQUEST EXPIRED' ||
      (error as any)?.data?.detail ===
        'EMAIL VERIFICATION REQUEST DOES NOT EXIST' ||
      (error as any)?.data?.detail === 'EMAIL VERIFICATION REQUEST ALREADY USED'
    ) {
      return (
        <Flex
          height='100%'
          flexDirection='column'
          gap={14}
          alignItems='center'
          justifyContent='center'
        >
          <Text variant='h4' fontWeight='fontWeightMedium'>
            <FormattedMessage id='emailVerificationRequest.errorRequestExpired' />
          </Text>
          <Button
            variant='primary'
            onClick={handleGoToLogin}
            style={{ marginLeft: 8 }}
          >
            <FormattedMessage id='emailVerificationRequest.goToLogin' />
          </Button>
        </Flex>
      );
    }

    return (
      <Flex height='100%' alignItems='center' justifyContent='center'>
        <Text variant='h4' fontWeight='fontWeightMedium'>
          <FormattedMessage id='emailVerificationRequest.somethingWentWrong' />
        </Text>
      </Flex>
    );
  }

  if (isSuccess) {
    return (
      <Flex
        height='100%'
        flexDirection='column'
        gap={12}
        alignItems='center'
        justifyContent='center'
      >
        <Text variant='h4' fontWeight='fontWeightMedium'>
          <FormattedMessage id='emailVerificationRequest.emailVerified' />
        </Text>
        <Button
          variant='primary'
          onClick={handleGoToLogin}
          style={{ marginLeft: 8 }}
        >
          <FormattedMessage id='emailVerificationRequest.goToLogin' />
        </Button>
      </Flex>
    );
  }

  return isLoading ? <Loader isLoading /> : null;
};

export default EmailVerificationRequest;
